import React, { Component } from 'react';
import { Radio, Input, Table, Row, Col, Card, CardHeader, CardBody, Button, CardFooter} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';
import { connect } from 'react-redux';
import { DataTable } from 'primereact/components/datatable/DataTable';
import { Column } from 'primereact/components/column/Column';
import { ColumnGroup } from 'primereact/components/columngroup/ColumnGroup';
import { Redirect } from 'react-router-dom';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/omega/theme.css';
import 'font-awesome/css/font-awesome.css';
import ReactHLS from 'react-hls';


class StoryboardAssetsPage extends Component {


  constructor(props) {
    super(props);
    this.state = {
       path:"",
       navigate:false,
       assetType:'',
       shotMedia:'',
       shotType:'',
       isHLS:false,
       isVideo:true,
       activeAssetUrl:'',
       rawAssets: [
                {Date: '09/02/2017', Project: 'Visit CBR', Storyboard: 'Dev-visitCBR-123456',AssetType:'Video',ShotType:'UGV', shot: '13', User: 'John Citizen',ShotMedia:'Movie',Favourite:"Yes"},
                {Date: '10/02/2017', Project: 'Visit CBR', Storyboard: 'Dev-visitCBR-123456',AssetType:'Image',ShotType:'DG', shot: '13', User: 'Chris Brown',ShotMedia:'Shot',Favourite:"Yes"},

            ],
       assets:[]
    }
    this.getSearchableAssets = this.getSearchableAssets.bind(this);
    this.renderTag = this.renderTag.bind(this);
  }

  resetFilters() {
    this.setState({
       assetType:'',
       shotMedia:'',
       shotType:'',
       isFavourite:false,
    })

  }


  getSearchableAssets() {
    let searchParameter ="";
    let skip = false;

    if(this.state.shotType === "DG" && this.state.shotMedia === "Shot" && this.state.assetType === "Video")
    {
      searchParameter = "?assetType=ShotExplanation&mediaType=Video";
    }
    else if(this.state.shotType === "DG" && this.state.shotMedia === "Shot" && this.state.assetType === "Image") {
      skip = true;

    }
    else if(this.state.shotType === "DG" && this.state.shotMedia === "Shot" && this.state.assetType === "Audio") {
      skip = true;

    }

    else if(this.state.shotType === "DG" && this.state.shotMedia === "Shot") {
      searchParameter = "?assetType=ShotExplanation";
    }

    else if(this.state.shotType === "DG" && this.state.shotMedia === "Movie" && this.state.assetType === "Video") {
      searchParameter = "?assetType=ScriptExplanation&mediaType=Video";
    }

    else if(this.state.shotType === "DG" && this.state.shotMedia === "Movie" && this.state.assetType === "Image") {
      skip = true;
    }

    else if(this.state.shotType === "DG" && this.state.shotMedia === "Movie" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "DG" && this.state.shotMedia === "Movie") {
      searchParameter = "?assetType=ScriptExplanation";
    }

    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Shot" && this.state.assetType === "Video") {
      searchParameter = "?assetType=FlicShot&mediaType=Video";
    }

    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Shot" && this.state.assetType === "Image") {
      skip = true;
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Shot" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Shot") {
      searchParameter = "?assetType=FlicShot";
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Movie" && this.state.assetType === "Video") {
      searchParameter = "?assetType=Flic&mediaType=Video";
    }

    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Movie" && this.state.assetType === "Image") {
      searchParameter = "?assetType=FlicThumbnail&assetType=FlicLandscapeStill&mediaType=Image";
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Movie" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Movie") {
      searchParameter = "?assetType=Flic";
    }
    else if(this.state.shotType === "DG" && this.state.assetType === "Image") {
      skip = true;
    }
    else if(this.state.shotType === "DG" && this.state.assetType === "Video") {
      searchParameter = "?assetType=ShotExplanation&assetType=ScriptExplanation&mediaType=Video";
    }
    else if(this.state.shotType === "DG" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "UGV" && this.state.assetType === "Image") {
      searchParameter = "?assetType=FlicThumbnail&assetType=FlicLandscapeStill&mediaType=Image";
    }
    else if(this.state.shotType === "UGV" && this.state.assetType === "Video") {
      searchParameter = "?assetType=Flic&assetType=FlicShot&mediaType=Video";
    }
    else if(this.state.shotType === "UGV" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "DG") {
      searchParameter = "?assetType=ScriptExplanation&assetType=ShotExplanation";
    }
    else if(this.state.shotType === "UGV") {
      searchParameter = "?assetType=Flic&assetType=FlicShot";
    }
    else if(this.state.shotType === "Stock" && this.state.shotMedia === "Shot" && this.state.assetType==="Image") {
      searchParameter = "?assetType=ShotThumbnail&assetType=ShotImage&mediaType=Image";
    }
    else if(this.state.shotType === "Stock" && this.state.shotMedia === "Shot" && this.state.assetType==="Video") {
      //Todo: This should be StockFlic

       searchParameter = "?assetType=OtherAsset";
    }
    else if(this.state.shotType === "Stock" && this.state.shotMedia === "Shot" && this.state.assetType==="Audio") {
       skip = true;
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Shot" ) {
      searchParameter = "?assetType=OtherAsset&assetType=ShotThumbnail&assetType=ShotImage&assetType=StockFlic";
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Video" ) {
      searchParameter = "?assetType=OtherAsset";
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Movie" && this.state.assetType==="Image" ) {
      searchParameter = "?assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage&mediaType=Image";
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Movie" && this.state.assetType==="Video" ) {
      skip = true;
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Movie" && this.state.assetType==="Audio" ) {
      skip = true;
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Movie" ) {
      searchParameter = "?assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage";
    }
    else if(this.state.shotType === "Stock") {
      searchParameter = "?assetType=ShotThumbnail&assetType=ShotImage&assetType=OtherAsset&assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage";
    }
    else if( this.state.shotMedia === "Movie" && this.state.assetType==="Video" ) {
      searchParameter = "?assetType=ScriptExplanation&assetType=Flic&mediaType=Video";
    }
    else if( this.state.shotMedia === "Movie" && this.state.assetType==="Image" ) {
      searchParameter = "?assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage&assetType=FlicThumbnail&assetType=FlicLandscapeStill&mediaType=Image";
    }
    else if( this.state.shotMedia === "Movie" && this.state.assetType==="Audio" ) {
      skip = true;
    }
    else if( this.state.shotMedia === "Movie" ) {
      searchParameter = "?assetType=ScriptExplanation&assetType=Flic&assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage&assetType=FlicThumbnail&assetType=FlicLandscapeStill";
    }
    else if(this.state.shotMedia==="Shot" && this.state.assetType==="Video" ) {
      searchParameter = "?assetType=ShotExplanation&assetType=FlicShot&assetType=StockFlic&mediaType=Video";

    }
    else if(this.state.shotMedia==="Shot" && this.state.assetType==="Image" ) {
      searchParameter = "?assetType=ShotImage&assetType=ShotThumbnail&mediaType=Image";

    }
    else if(this.state.shotMedia==="Shot" && this.state.assetType==="Audio" ) {
      skip = true;

    }
    else if(this.state.shotMedia==="Shot") {
      searchParameter = "?assetType=ShotExplanation&assetType=OtherAsset&assetType=FlicShot&assetType=StockFlic&assetType=ShotImage&assetType=ShotThumbnail";
    }
    else if(this.state.assetType==="Image") {
      searchParameter = "?assetType=ShotImage&assetType=ShotThumbnail&assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage&assetType=FlicThumbnail&assetType=FlicLandscapeStill&mediaType=Image";
    }
    else if(this.state.assetType==="Video") {
      searchParameter = "?assetType=ShotExplanation&assetType=OtherAsset&assetType=ScriptExplanation&assetType=FlicShot&assetType=Flic";

    }
    else if(this.state.assetType==="Audio") {
      skip = true;
    }
    else if(this.state.assetType === '' && this.state.shotMedia === '' && this.state.shotType === '') {
      searchParameter = "";
    }

    if(searchParameter ==="") {
      searchParameter+="?pageSize=2000";
    } else {
      searchParameter+="&pageSize=2000";
    }

    if(!skip) {

      let authToken = this.props.user.authToken;
      let cId = this.props.user.customerId;

      $.ajax({
          type: 'GET',
          url: `https://screen.mobflic.com/v1/customers/${cId}/assets${searchParameter}`,
          beforeSend: function (xhr) {
              xhr.setRequestHeader("X-Auth-Token",authToken);
          },
          success: (res) => {
              this.setState({
                rawAssets:res.result.hits,
                assets:[]
              },() => {
                let processedAssetItem;
                let newAssets = [];
                for(var key in this.state.rawAssets) {
                  if (this.state.rawAssets[key].assetId!="") {

                    let date = "";
                    date = this.state.rawAssets[key].assetId.substring(0,12).split('/');
                    if(date.length > 2)
                    {
                      date = date[0] + "/" + date[1] + "/" + date[2];
                    }

                    processedAssetItem = {
                      date:date,
                      projectType:this.state.rawAssets[key].projectTitle,
                      scriptTitle:this.state.rawAssets[key].scriptTitle,
                      shotNumber:this.state.rawAssets[key].shotNumber,
                      shotTitle:this.state.rawAssets[key].name,
                      user:this.state.rawAssets[key].userEmail,
                      mediaType:this.state.rawAssets[key].mediaType?this.state.rawAssets[key].mediaType:"Other",
                      assetType:this.state.rawAssets[key].assetType,
                      assetId:this.state.rawAssets[key].assetId,
                      projectId:this.state.rawAssets[key].projectId,
                      scriptId:this.state.rawAssets[key].scriptId,
                      flicId:this.state.rawAssets[key].flicId,
                      flicShotId:this.state.rawAssets[key].flicShotId
                    }

                    processedAssetItem.isVideo = processedAssetItem.mediaType == "Image"?false:true;

                    if (processedAssetItem.assetId) {
                      processedAssetItem.isHLS = processedAssetItem.assetId.substr(processedAssetItem.assetId.length-1,1)=="8";

                      if (processedAssetItem.assetType=="Flic" || processedAssetItem.assetType=="FlicShot" || processedAssetItem.assetType=="FlicLandscapeStill" || processedAssetItem.assetType=="FlicThumbnail") {
                        processedAssetItem.url = "https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(processedAssetItem.assetId) + "?storyboardId=" + processedAssetItem.scriptId + "&flicId=" + processedAssetItem.flicId + "&authToken=" + this.props.user.authToken;
                      }
                      else {
                        processedAssetItem.url = "https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(processedAssetItem.assetId) + "?storyboardId=" + processedAssetItem.scriptId + "&authToken=" + this.props.user.authToken;
                      }
                    }

                    switch(this.state.rawAssets[key].assetType)
                    {
                    case "ShotExplanation":
                        processedAssetItem.sourceType="DG";
                        processedAssetItem.shotMedia="Shot";

                      break;
                    case "ScriptExplanation":
                        processedAssetItem.sourceType="DG";
                        processedAssetItem.shotMedia="Movie";
                      break;
                    case "FlicShot":
                         processedAssetItem.sourceType="UGV";
                         processedAssetItem.shotMedia="Shot";
                      break;
                    case "Flic":
                         processedAssetItem.sourceType="UGV";
                         processedAssetItem.shotMedia="Movie";
                      break;
                    case "ShotImage":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Shot";
                      break;

                    case "ShotThumbnail":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Shot";
                      break;

                    case "ScriptThumbnail":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Movie";
                      break;

                    case "ScriptPortraitImage":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Movie";
                      break;

                    case "ScriptLandscapeImage":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Movie";
                      break;

                    case "FlicThumbnail":
                         processedAssetItem.sourceType="UGV";
                         processedAssetItem.shotMedia="Movie";
                      break;

                    case "FlicLandscapeStill":
                        processedAssetItem.sourceType="UGV";
                        processedAssetItem.shotMedia="Image";
                      break;

                    case "OtherAsset":
                        processedAssetItem.sourceType="Stock";
                        processedAssetItem.shotMedia="Shot";
                      break;

                    default:
                        processedAssetItem.sourceType="Other";
                        processedAssetItem.shotMedia="Other";
                  }

                  newAssets.push(processedAssetItem);
                  }
                }
                this.setState({
                  assets:newAssets
                })
              })
          },
          error: (res,a,b) => {
              console.log(res);
              console.log(a);
              console.log(b);
          }
      });
    } else {
      this.setState({assets:[]})
    }

  }

  renderTag() {
    if (this.state.selectedSale && this.state.selectedSale.url) {
      if (this.state.selectedSale.isVideo) {
        if(this.state.selectedSale.isHLS) {
          return (
            <ReactHLS style={{"width":"auto", "height":"300"}} videoProps={{"width":"auto", "height":"300"}} url={this.state.selectedSale.url}/>
            )
        } else {
          return (
              <video style={{"width":"auto", "height":"300"}}  width="auto" height="300" controls src={this.state.selectedSale.url}></video>
            )
        }
      } else {
        return (
           <img style={{"width":"100%", "height":"100%"}} src={this.state.selectedSale.url} />
        )
      }
    }
  }

  componentWillMount() {
        if(!this.props.user.isLoggedIn) {
          this.setState({
            path:"login",
            navigate:true

          })
        }
        this.getSearchableAssets();
  }

  render() {
    const { navigate, path } = this.state

    // here is the important part
    if (navigate) {
      return <Redirect to={ "/" + path } push={true} />
    }

    return (

      <div className="animated fadeIn">
         <Row>
          <Col xs="8">

           <Card>
              <CardHeader>
                View/Watch Asset
              </CardHeader>
              <CardBody>
                <Row>

                  <Col style={{"height":"300px"}}>
                  {
                    this.renderTag()
                  }
                  </Col>
                </Row>

              </CardBody>
            </Card>
          </Col>

           <Col xs="1">


          </Col>

          <Col xs="2">
             <p> Filter By</p>
             <p> <Input type="radio"  name="radio1"  checked={this.state.assetType==="Image"} onChange={()=>{this.setState({assetType:'Image'}, () => {console.log(this.state.assetType);this.getSearchableAssets()});}}/> Image  </p>
             <p> <Input type="radio"  name="radio1"  checked={this.state.assetType==="Video"} onChange={()=>{this.setState({assetType:'Video'}, () => {console.log(this.state.assetType);this.getSearchableAssets()});}}/> Video  </p>
             <p> <Input type="radio"  name="radio1"  checked={this.state.assetType==="Audio"} onChange={()=>{this.setState({assetType:'Audio'}, () => {console.log(this.state.assetType);this.getSearchableAssets()});}}/> Audio </p>

             <p> <Input type="radio"  name="radio2"  checked={this.state.shotType==="DG"} onChange={()=>{this.setState({shotType:'DG'}, () => {console.log(this.state.assetType);this.getSearchableAssets()});}}/> DG </p>
             <p> <Input type="radio"  name="radio2"  checked={this.state.shotType==="UGV"} onChange={()=>{this.setState({shotType:'UGV'}, () => {console.log(this.state.assetType);this.getSearchableAssets()});}}/> UGV  </p>
             <p> <Input type="radio"  name="radio2"  checked={this.state.shotType==="Stock"} onChange={()=>{this.setState({shotType:'Stock'}, () => {console.log(this.state.assetType);this.getSearchableAssets()});}}/> Stock </p>


             <p> <Input type="radio"  name="radio3"  checked={this.state.shotMedia==="Movie"} onChange={()=>{this.setState({shotMedia:'Movie'}, () => {console.log(this.state.assetType);this.getSearchableAssets()});}}/> Movie  </p>
             <p> <Input type="radio"  name="radio3"  checked={this.state.shotMedia==="Shot"} onChange={()=>{this.setState({shotMedia:'Shot'}, () => {console.log(this.state.assetType);this.getSearchableAssets()});}}/> Shot </p>
             <p> <Button style={{"borderRadius":"5px"}} onClick={() => { this.setState({
               assetType:'',
               shotMedia:'',
               shotType:'',
               isFavourite:false,
            },() => this.getSearchableAssets())}} color="danger"> Reset </Button> </p>

          </Col>

         </Row>

         <Row style={{"marginTop":"20px"}}>
          <Col>
           <DataTable value={this.state.assets} paginator={true} rows={200} sortField="brand" selectionMode="single"
                      selection={this.state.selectedSale} onSelectionChange={ (e) =>{ this.setState({selectedSale: e.data})}} sortOrder={1}>

           <Column field="date" header="Date" style={{width:'90px'}} filterPlaceholder="Search" filter={true} sortable={true}/>
           <Column field="projectType" header="Project Type" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
           <Column field="scriptTitle" header="Storyboard" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
           <Column field="shotNumber" header="Shot Number" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
           <Column field="shotTitle" header="Shot Title" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
           <Column field="user" header="User" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
           <Column field="mediaType" header="Media" style={{width:'70px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
           <Column field="sourceType" header="Source" style={{width:'70px'}} filterPlaceholder="Search" filter={true} sortable={true}/>
           <Column field="shotMedia" header="AssetType" style={{width:'90px'}} filterPlaceholder="Search" filter={true} sortable={true}/>

            </DataTable>
          </Col>
         </Row>
      </div>
    )
  }
}

function mapStateToProps(state) {
    return {
        user: state.activeUser,
    };
}



export default connect(mapStateToProps)(StoryboardAssetsPage);



// WEBPACK FOOTER //
// ./src/views/Components/StoryboardAssets/StoryboardAssets.js